import { createSelector } from 'reselect';
import {
    transformChallenges,
    transformTags,
    transformUsers,
    transformCountries,
    transformReportData,
    transformCities,
} from './transformers';
import { transformMapData } from '../../map/transformers';

export const getChallengesState = (state) => state.downloads.challenges || [];

export const getCountriesState = (state) => state.downloads.countries || [];

export const getSelectedCountriesIds = (state) =>
    state.downloads.selectedCountriesIds || [];

export const getCountriesLoadingState = (state) =>
    state.downloads.loadingCountries || [];

export const getCities = createSelector(
    getCountriesState,
    getSelectedCountriesIds,
    (countries, selectedIds) => transformCities(countries, selectedIds),
);

export const getTagsState = (state) => state.downloads.tags || [];

export const getUsersState = (state) => state.downloads.users || [];

export const getTotalCountState = (state) => state.downloads.totalCount || 0;

export const getPreviewReportState = (state) =>
    state.downloads.previewReport || [];

export const getReportState = (state) => state.downloads.report || [];

export const getPreviewReportLoadingState = (state) =>
    state.downloads.previewReportLoading || false;

export const getCSVReportLoadingState = (state) =>
    state.downloads.csvReportLoading || false;

export const getChallenges = createSelector(
    getChallengesState,
    (challengesState) => transformChallenges(challengesState),
);

export const getCountries = createSelector(
    getCountriesState,
    (countriesState) => transformCountries(countriesState),
);

export const getCountriesLoading = createSelector(
    getCountriesLoadingState,
    (loading) => loading,
);

export const getTags = createSelector(getTagsState, (tagsState) =>
    transformTags(tagsState),
);

export const getUsers = createSelector(getUsersState, (usersState) =>
    transformUsers(usersState),
);

export const getPreviewReport = createSelector(
    getPreviewReportState,
    (report) => report,
);

export const getCSVReport = createSelector(getReportState, (report) => report);

export const getCSVReportCOMBO = createSelector(getReportState, (report) =>
    transformReportData(report),
);

export const getPreviewReportLoading = createSelector(
    getPreviewReportLoadingState,
    (loading) => loading,
);
export const getCSVReportLoading = createSelector(
    getCSVReportLoadingState,
    (loading) => loading,
);

export const getTotalCount = createSelector(
    getTotalCountState,
    (total) => total,
);

export const getSelectedZoom = (state) => state.downloads.zoom;
export const getSelectedDimension = (state) => state.downloads.dimensions;
export const getMapData = (state) =>
    transformMapData(state.downloads.mapData) || [];
